import { AuthUtils } from '@space-shell/common/utils/auth'

import type { RequestConfig } from './manager'
import { httpManager, whenRequestWithError, whenResponseWithError } from './manager'

const apiSparkle = httpManager.create({ baseURL: process.env.API_SPARKLE })

apiSparkle.interceptors.request.use((request: RequestConfig) => {
  return AuthUtils.addTokenToRequest(request)
}, whenRequestWithError)

apiSparkle.interceptors.response.use((response) => response, whenResponseWithError)

export default apiSparkle
